import axios, { AxiosResponse } from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_PLANETDIET_API_URL;
axios.defaults.headers.post['Content-Type'] = 'text/json';

export type QuestionnaireStatus = {
    id: string // The id of the questionnaireResponse
    name: string // The name of the questionnaire
    title: string
    participantId: string // The id of the participantId
    questionnaireId: string // The id of the questionnaire
    isCompleted: boolean // True if the questionnaire response is isComplete
    completedDate: string | null // The completed date of the quesionnaire response
    version: string
    expectedCompletionTime: number
    groupName: string
}

export type QuestionnaireData = {
    id: string // The id of the questionnaire
    name: string // The name of the questionnaire
    questionnaireJson: string // The JSON of the questionnaire
    version: string
    dataMentorQuestionnaireId: string
}

type GetQuestionnairesStatusResponse = {
    questionnaireResponses: QuestionnaireStatus[]
}

const apiKey = process.env.REACT_APP_PLANETDIET_API_KEY;

export const QuestionnaireAPI = {
    getQuestionnairesResponse: async (token: string): Promise<GetQuestionnairesStatusResponse> => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };

        const response = await axios.get('/questionnaire/questionnaireresponses/state', { headers });
        if (response.status === 200) {
            return response.data;
        } else {
            return badStatusError(response);
        }
    },
    getQuestionnaire: async (id: string, token: string): Promise<QuestionnaireData> => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };

        const response = await axios.get(`/questionnaire/questionnaires/${id}`,
            { headers }
        );

        if (response.status === 200) {
            return response.data;
        } else {
            return badStatusError(response);
        }
    },
    setQuestionnaireCompleted: async (id: string, secondsToCompleteDuration: number, version: string,  token: string): Promise<void> => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };

        const response = await axios.put('/questionnaire/questionnaireresponses/update',
            {
                questionnaireId: id,
                secondsToCompleteDuration: secondsToCompleteDuration,
                version: version,
            },
            { headers }
        );

        if (response.status === 200) {
            return response.data;
        } else {
            return badStatusError(response);
        }
    },
    sendQuestionnaireCompleted: async (id: string, questionnaireId: string, questionnaireName: string, version: string, startedTime: string, completedTime: string, json: any, token: string, dataMentorQuestionnaireId: string |null): Promise<void> => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };

        const response = await axios.post('/cbmrtransfer/UploadQuestionnaireResult',
            {
                participantId: id,
                questionnaireId: questionnaireId,
                questionnaireName: questionnaireName,
                version: version,
                startedTime: startedTime,
                completedTime: completedTime,
                surveyResult: json,
                dataMentorQuestionnaireId,
            },
            { headers }
        );

        if (response.status === 200) {
            return response.data;
        } else {
            return badStatusError(response);
        }
    },

    uploadScreeningQuestionnaire: async (participantId: string, questionnaireDocument: string, token: string): Promise<void> => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };

        const response = await axios.post('/cbmrtransfer/UploadScreeningQuestionnaire', {
            participantId: participantId,
            questionnaireDocument: questionnaireDocument,
        }, { headers });

        if (response.status === 200) {
            return response.data;
        } else {
            return badStatusError(response);
        }
    },
};

const badStatusError = (response: AxiosResponse) => {
    throw new Error(`Invalid response: ${response.status} - ${response.data}`);
};